import { render, staticRenderFns } from "./MoonLandingPageHeader.vue?vue&type=template&id=454ea13f&scoped=true"
import script from "./MoonLandingPageHeader.vue?vue&type=script&lang=js"
export * from "./MoonLandingPageHeader.vue?vue&type=script&lang=js"
import style0 from "./MoonLandingPageHeader.vue?vue&type=style&index=0&id=454ea13f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "454ea13f",
  null
  
)

export default component.exports